<template>
	<div>
		<div class="bj_img_h">
			<div style="margin-top: 20px; margin-bottom: 20px;">
				<div>
					<div style="width: 100%;">
						<img style="width: 100%;border-radius:5px;"
							src="https://img.hsnms.com/20220412/1649693440.webp" />
					</div>
				</div>
			</div>


			<div class="app-container">
				<div class="the-container">
					<el-tabs stretch="" v-model="usable" :tab-position="tabPosition" @tab-click="handleClick">
						<el-tab-pane v-for="(tab,index) in tabs" :key="index" :name="tab.name" :label="tab.label">
							<div v-show="usable==='1'">

								<div style="margin-bottom: 20px;" class="col-xs-6" v-for="(item, index) in [2,3,3,2,4,5,2,4,5,4]">
									
									<div style="position:relative;width:100%;">
										<img style="width: 100%; border-radius:3%;"
											src="http://www.baiduhrb.com/fjhht/upload/Project/202003/3542323865e5fcc08644c3_400_285_3.jpg" />
										<div style="position:absolute; width:100%;left:0;top:0;">
											<div class="loupan">椒江</div>
										</div>
										<div style="position:absolute; left:0;top:80%;">
											<div class="jiage">13500元/㎡</div>
										</div>
									</div>
									<h5>华润置地悦府</h5>
								</div>

							</div>
							<div v-show="usable==='2'">


								<div class="span12" style="margin-top: 5px;margin-bottom: 5px;"
									v-for="(item, index) in [2,3,4,4]">
									<!--t_10-->
									<div class="row">
										<div class="col-3" style="padding-right:1px;">
											<div style="position:relative;width:100%;">
												<img style="width: 100%; border-radius:3%;"
													src="https://img.hsnms.com/20220412/1649693925.webp" />
												<div style="position:absolute;left:0;top:0;">
													<div class="zhibo">直播中</div>
												</div>
											</div>
										</div>
										<div class="col-9">
											<h4>华鸿地产第三期，案场直播</h4>
											<h6>播放量：29485</h6>
										</div>

									</div>
									<hr />
								</div>


							</div>
							<div v-show="usable==='3'">


								<div class="span12" style="margin-top: 5px;margin-bottom: 5px;"
									v-for="(item, index) in [2,3,4,4]">
									<!--t_10-->
									<div class="row">
										<div class="col-4" style="padding-right:1px;">
											<div style="position:relative;width:100%;">
												<img style="width: 100%; border-radius:3%;"
													src="https://img.hsnms.com/20220412/1649693925.webp" />
												<div style="position:absolute;left:0;top:0;">
													<div class="zhibo">直播中</div>
												</div>
											</div>
										</div>
										<div class="col-8">
											<h4>华鸿地产第三期，案场直播</h4>
											<h5>主持人：大白</h5>
											<h6>播放量：29485</h6>
										</div>

									</div>
									<hr />
								</div>



							</div>
							<div v-show="usable==='4'">
								<h1>部门管理</h1>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
			<div style="height: 20px;"></div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				tabPosition: 'top',
				usable: '1',
				tabs: [{
						name: '1',
						label: '活动报名'
					},
					{
						name: '2',
						label: '活动展示'
					}
				]
			}
		},
		methods: {
			route1: function(myurl) {
				window.open(myurl,"_blank");
			},
			handleClick(tab) {
				console.log(tab)
			}
		}
	}
</script>

<style>
	.bin_tijiao_data {
		height: 50px;
		width: 100%;
		font-size: 16px;
		opacity: 0.6;
	}
	.header {
		height: 20rem;
		color: #fff;
		background: url(http://www.baiduhrb.com/fjh/images/user_bg.png);
		background-size: 100% 100%;
	}

	.header .logo {
		display: block;
		float: left;
		margin-left: .8rem;
		margin-top: -4rem;
	}

	.header .logo img {
		position: relative;
		overflow-x: hidden;
		width: 45%;
		height: auto;
		top: 0px;
	}

	.m-slider {
		overflow-x: hidden;
		position: relative;
		margin-top: -10rem;
		border-radius: .45em;
	}

	.zhibo {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.loupan {
		opacity: 0.6;
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.jiage {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.h_hei {
		border-left: 5px solid #c5114f;
		padding-left: 5px;
	}

	.container-fluid {
		margin-top: 0px !important;
		max-width: 1200px;
	}

	.el-tabs__item {
		font-size: 16px !important;


	}

	.el-tabs__item is-top is-active {
		width: 50% !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/jjgh/zgwh.vue